// extracted by mini-css-extract-plugin
export default {"cls1":"LVp1vsezuBLRMlbmCM7G","cls2":"FVTtfd16Z1rKuGRW170M LVp1vsezuBLRMlbmCM7G"};